import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Radio, Plus, RefreshCw } from 'lucide-react';

export const TelegramStatusCard = ({ telegramStatus }) => (
  <div className="bg-[#121212] border border-[#27272A] p-6">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold uppercase" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
        Stato Telegram Bot
      </h3>
      <div className="flex items-center gap-2">
        <div className={`status-dot ${telegramStatus?.configured ? 'connected' : 'disconnected'}`} />
        <span className="text-xs font-mono uppercase tracking-wider text-[#A1A1AA]">
          {telegramStatus?.configured ? 'Connesso' : 'Non configurato'}
        </span>
      </div>
    </div>
    {telegramStatus?.configured ? (
      <div className="space-y-2 text-sm text-[#A1A1AA]">
        <p><span className="text-[#71717A]">Canale VVF_Interventi:</span> {telegramStatus.channel_id || 'Non impostato'}</p>
      </div>
    ) : (
      <div className="flex items-center gap-3 text-[#A1A1AA]">
        <Radio className="w-5 h-5" />
        <span>Configura il bot Telegram nelle impostazioni</span>
      </div>
    )}
    <Link to="/settings">
      <Button className="mt-4 bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white rounded-none uppercase tracking-wide text-sm" data-testid="configure-telegram-btn">
        Configura
      </Button>
    </Link>
  </div>
);

export const QuickActionsCard = ({ onRefresh }) => (
  <div className="bg-[#121212] border border-[#27272A] p-6">
    <h3 className="text-lg font-semibold uppercase mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
      Azioni Rapide
    </h3>
    <div className="space-y-3">
      <Link to="/intervention/new" className="block">
        <Button className="w-full bg-[#E3000F] hover:bg-transparent hover:border-[#E3000F] text-white rounded-none uppercase tracking-wide border-2 border-transparent hover:text-[#E3000F] transition-all" data-testid="new-intervention-btn">
          <Plus className="w-5 h-5 mr-2" />
          Nuovo Intervento Manuale
        </Button>
      </Link>
      <Button onClick={onRefresh} className="w-full bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white rounded-none uppercase tracking-wide" data-testid="refresh-btn">
        <RefreshCw className="w-5 h-5 mr-2" />
        Aggiorna Dati
      </Button>
    </div>
  </div>
);
